import { defineStore } from 'pinia';
import { useCookies } from '@/composables/useCookies';
import { getSharpCharts2ChartImageUrlParametersObject } from '@/composables/getSharpCharts2ChartImageUrlParametersObject';
import { INVALID_CHART_RECID } from '@/composables/isValidChartRecid';
import { buildUrlString } from '@/utils/buildUrlString';
import { INSPECTOR_COOKIE_KEY, INSPECTOR_COOKIE_ON_VALUE } from '@/enums/cookies';
import { LayoutStore } from '@/types/LayoutStore';

function stateFn(): LayoutStore {
  const { getCookie } = useCookies();
  const isInspectingInitialValue = getCookie(INSPECTOR_COOKIE_KEY).trim().toLowerCase() === INSPECTOR_COOKIE_ON_VALUE.toLowerCase();

  return {
    chartImageUrlStringRandomNumber: Date.now(),
    symbol: '',
    period: '',
    chartType: '',
    range: '',
    rangeBar: '',
    rangeGap: '',
    rangeYears: '',
    rangeMonths: '',
    rangeDays: '',
    rangeStartDate: '',
    rangeEndDate: '',
    perfChartSymbolsString: '',
    useMainChartSymbolAsBaseline: false,
    annotationsRecid: INVALID_CHART_RECID,
    i: '',
    inspectorDataString: '',
    modalType: '',
    isInspecting: isInspectingInitialValue,
    isInspectorInUse: false,
    isDraggingChartToResize: false,
    isChartComponentMounted: false,
    hasChartImageLoadAttemptCompleted: false
  };
}

const useLayoutStore = defineStore('layoutStore', {
  state: stateFn,
  getters: {
    isModalVisible: function (state) {
      return !!state.modalType;
    },
    isDragNDropping: function (state) {
      return state.isDraggingChartToResize; // TODO: add 'or' clauses here to also return true when indicators are being dragged n' dropped and ChartStyle Buttons too
    },
    chartImageUrlString: function (state) {
      const sharpCharts2ChartImageUrlParametersObject = getSharpCharts2ChartImageUrlParametersObject(false, state);

      return buildUrlString('/c-sc/sc/', { areParametersAlreadyUrlEncoded: true, parameters: { ...sharpCharts2ChartImageUrlParametersObject, r: state.chartImageUrlStringRandomNumber.toString() }});
    },
    sharpCharts2ChartImageUrlData: function (state) {
      return {
        symbol: state.symbol,
        period: state.period,
        chartType: state.chartType,
        range: state.range,
        rangeBar: state.rangeBar,
        rangeGap: state.rangeGap,
        rangeYears: state.rangeYears,
        rangeMonths: state.rangeMonths,
        rangeDays: state.rangeDays,
        rangeStartDate: state.rangeStartDate,
        rangeEndDate: state.rangeEndDate,
        perfChartSymbolsString: state.perfChartSymbolsString,
        useMainChartSymbolAsBaseline: state.useMainChartSymbolAsBaseline,
        annotationsRecid: state.annotationsRecid,
        i: state.i
      };
    }
  },
  actions: {}
});

export {
  useLayoutStore
};
